import { AxiosResponse } from "axios";
import {
  InvDropDown,
  InvestigationObject,
  InvestigationQuery,
  InvestigationResponse,
} from "../interfaces/NJPORT/InvestigationLog.interface";
import AuthenticatedAPIReq from "./AuthenticatedAPIReq.service";

export async function submitInvestigation(
  data: InvestigationObject
): Promise<InvestigationObject> {
  const res: AxiosResponse<InvestigationObject> =
    await AuthenticatedAPIReq.post("/api/NJPORT/SetPortInvestigation", data);
  return res.data;
}

export async function searchInvestigation(
  data: InvestigationQuery
): Promise<InvestigationResponse> {
  let res: AxiosResponse<InvestigationResponse> =
    await AuthenticatedAPIReq.post("/api/NJPORT/List", data);
  return res.data;
}

export async function DeleteInvestigationReport(data: any): Promise<any> {
  let res: AxiosResponse<any> = await AuthenticatedAPIReq.post(
    "/api/NJPORT/SetPortInvestigation",
    data
  );
  return res.data;
}

export async function InvestigationDropDown(data: any): Promise<InvDropDown[]> {
  let res: AxiosResponse<InvDropDown[]> = await AuthenticatedAPIReq.get(
    "/api/Dropdown/PORT",
    data
  );
  return res.data;
}
